export const SITE = {
    brand: "NFC Pro",
    domain: "NFCpro.com",
    phone: "(928) 606-2398",
    email: "braeden@thenfcpro.com",
    social: {
        instagram: "https://instagram.com",
        facebook: "https://facebook.com",
        tiktok: "https://tiktok.com",
        linkedin: "https://linkedin.com",
    },
};

const A = "https://customer-assets.emergentagent.com/job_tap-engagement/artifacts";

export const PHOTOS = {
    stickers: [
        `${A}/szmtgqu4_0c40d44a-dc9f-4d78-963d-a178fcd7f077.avif`,
        `${A}/br0glyhr_d4d6f6be-7bf9-4678-854e-401e8023a3d0.avif`,
        `${A}/3ax6pulg_ef5cce64-4ea9-4df2-99eb-d75e441a5f5f.avif`,
    ],
    stands: [
        `${A}/198tpniv_30abadef-b552-4bb6-b3eb-602787a71d1a.avif`,
        `${A}/y80duteo_682d863a-3618-11f0-b974-0a580a634d11.avif`,
        `${A}/5p14yfhr_fa3e135c-3ff0-45d0-a2fb-6d9fdf5610d9.avif`,
        `${A}/jmu5u0bx_6eca386a-ec36-4498-a90b-63c0248b3b83.avif`,
    ],
    plaques: [
        `${A}/10yjte80_25074924-0403-4317-9b50-02cf3ec04f72.avif`,
        `${A}/zueg4t0q_0acb1a5d-bd92-4f6b-af71-f748638cfc63.avif`,
        `${A}/99mizljc_3afa9d1b-89f1-41b1-a01f-7e0a48f1be18.avif`,
        `${A}/76le3nk5_592cd284-65c0-425d-8082-6708c5630f26.avif`,
        `${A}/fgtgxkoo_6608e988-0cff-4140-b58e-566caa043c67.avif`,
    ],
};

export const MEDIA = {
    heroMain: PHOTOS.plaques[0],
    heroBg:
        "https://static.prod-images.emergentagent.com/jobs/8c991e9f-ef06-4362-90e9-731401775850/images/db25bfa5cd40ca06048ce94571bdfaa83966c5b8e7bee81fb0c018da105c60ca.png",
    productStanding: PHOTOS.stands[0],
    productPlaque: PHOTOS.plaques[0],
    productSticker: PHOTOS.stickers[0],
    mockupUi:
        "https://static.prod-images.emergentagent.com/jobs/8c991e9f-ef06-4362-90e9-731401775850/images/fc8c6da906384e3b071b7d825a47137385c9b141f42c42f6d7f7c41c22a6de01.png",
};

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
